export default {
    configurationSite(state){
        return state.configurationSite;
    },
    donorPortalSettings(state){
        return state.donorPortalSettings;
    },
    siteCustomizationData(state){
        return state.siteCustomizationData;
    },
    lifeTimeLocationSettings(state){
        return state.siteCustomizationData.previousDonations.lifeTimeLocationSettings;
    },

    crmSettings(state){
        return state.crmSettings
    },
    hash(state) {
        return  state.siteCustomizationData.hash
    },
    spinner: (state) => state.showSpinner,

    // eslint-disable-next-line no-unused-vars
    messages: (state, rootGetters)=>(nameMessage)=>{
        const dataResponseMutation = {
            $PhoneSupport: state.siteCustomizationData.headerFooter.phone,
            $EmailDonor: rootGetters['donorInformation/email'],
            $FirstNameDonor: rootGetters['donorInformation/firstName'],
            $LastNameDonor: rootGetters['donorInformation/lastName'],
        }
        let message = state.siteCustomizationData.messages[nameMessage]
        Object.keys(dataResponseMutation).forEach(el=>message = message.replace(el, dataResponseMutation[el]))
        return message
    }
}